import Swiper from 'swiper';
import {Navigation} from "swiper/modules";

new Swiper('.component-banner-slider .swiper', {
  modules: [Navigation],
  slidesPerView: 5,
  spaceBetween: 140,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  centerInsufficientSlides: true,
  breakpoints: {
    300: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 100,
    },
    1600: {
      spaceBetween: 140,
    }
  }
});
